/* Glenn Jones Art – shared wishlist
   One list (saved in the browser) used by the AI Art Finder, Shop by Palette,
   product pages, the header drawer and the Art Wall Planner. */
(function () {
  if (window.GJAWishlist) return;

  var KEY = 'gja-wishlist-v1';
  var MAX = 60;
  var subs = [];

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  var items = read();

  function emit() {
    subs.forEach(function (f) { try { f(items.slice()); } catch (e) {} });
    syncButtons();
    document.dispatchEvent(new CustomEvent('gja:wishlist', { detail: { items: items.slice() } }));
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    emit();
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) { items = read(); emit(); } });

  function find(h) { for (var i = 0; i < items.length; i++) if (items[i].h === h) return items[i]; return null; }
  function has(h) { return !!find(h); }

  var infoCache = {}, rawCache = {};
  function info(h) {
    if (!infoCache[h]) {
      infoCache[h] = fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          rawCache[h] = p;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          return { t: p.title, img: img, p: p.price, pv: !!p.price_varies, ty: p.type || '' };
        })
        .catch(function () { delete infoCache[h]; return null; });
    }
    return infoCache[h];
  }
  function enrich(h) {
    info(h).then(function (d) {
      var it = find(h); if (!it || !d) return;
      it.t = d.t; it.img = it.img || d.img; it.p = d.p; it.pv = d.pv; it.ty = d.ty;
      save();
    });
  }

  function add(h, meta) {
    if (!h || has(h)) return;
    meta = meta || {};
    items.unshift({ h: h, t: meta.t || '', img: meta.img || '', p: null, at: Date.now() });
    if (items.length > MAX) items.length = MAX;
    save();
    toast('Saved to your wishlist', true);
    enrich(h);
  }
  function remove(h) { items = items.filter(function (i) { return i.h !== h; }); save(); }
  function toggle(h, meta) { if (has(h)) { remove(h); toast('Removed from your wishlist'); } else add(h, meta); }

  /* ---------- size / frame choices and cart ---------- */
  var SKEY = 'gja-wishlist-sel-v1', sel = {};
  try { sel = JSON.parse(localStorage.getItem(SKEY)) || {}; } catch (e) {}
  function saveSel() { try { localStorage.setItem(SKEY, JSON.stringify(sel)); } catch (e) {} }
  function product(h) { return rawCache[h] ? Promise.resolve(rawCache[h]) : info(h).then(function () { return rawCache[h] || null; }); }
  function chosenVariant(p, h) {
    var v = null, i;
    if (sel[h]) for (i = 0; i < p.variants.length; i++) if (p.variants[i].id === sel[h]) v = p.variants[i];
    if (!v) for (i = 0; i < p.variants.length; i++) if (p.variants[i].available) { v = p.variants[i]; break; }
    return v || p.variants[0];
  }
  // best variant for a changed option, keeping the other choices where that combination exists
  function matchVariant(p, vals, changed) {
    var best = null, bestScore = -1;
    p.variants.forEach(function (v) {
      if (v.options[changed] !== vals[changed]) return;
      var score = 0;
      v.options.forEach(function (o, i) { if (o === vals[i]) score += 2; });
      if (v.available) score += 1;
      if (score > bestScore) { bestScore = score; best = v; }
    });
    return best;
  }
  function optLabel(name) { return /size/i.test(name) ? 'Size' : /frame/i.test(name) ? 'Frame' : name; }
  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart_count').forEach(function (e) { e.textContent = c.item_count; });
    }).catch(function () {});
  }
  function addToCart(ids, btn) {
    if (!ids.length) return;
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); return d; }); })
      .then(function () {
        updateCartCount();
        toast(ids.length > 1 ? ids.length + ' prints added to your cart' : 'Added to your cart', false, '<a href="/cart">View cart</a>');
      })
      .catch(function (err) { toast(err.message || 'Could not add to cart'); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }

  /* ---------- helpers ---------- */
  function handleFrom(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function sized(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  // only paper art prints can go in the Art Wall Planner (not canvas, tea towels, calendars etc.)
  function isPlannerPrint(it) { return it.ty ? /^\s*art print\s*$/i.test(it.ty) : !/canvas|tea-towel|towel|calendar|puzzle|card/i.test(it.h); }
  function shortTitle(t) { return String(t || '').replace(/\s+Art Print$/i, ''); }

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.4-4.5-9.4-9C1.2 8.1 3.2 4.6 6.7 4.6c2.1 0 3.5 1.2 5.3 3.1 1.8-1.9 3.2-3.1 5.3-3.1 3.5 0 5.5 3.5 4.1 6.7-2 4.5-9.4 9-9.4 9z"/></svg>';

  /* ---------- styles ---------- */
  var css = '' +
    '.gjaw-heart{position:absolute;bottom:8px;right:8px;z-index:3;width:38px;height:38px;border:0;padding:0;margin:0;background:none;box-shadow:none;display:grid;place-items:center;cursor:pointer;color:#111;transition:transform .15s}' +
    '.gjaw-heart:hover{transform:scale(1.08)}' +
    '.gjaw-heart svg{width:24px!important;height:24px!important;filter:drop-shadow(0 0 1.5px rgba(255,255,255,.95)) drop-shadow(0 1px 2px rgba(0,0,0,.25))}' +
    '.gjaw-heart svg,.gjaw-save svg,.gjaw-pdp svg,.gjaw-hdr svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:1.8}' +
    '.gjaw-heart[aria-pressed="true"],.gjaw-save[aria-pressed="true"],.gjaw-pdp[aria-pressed="true"]{color:#d6334a}' +
    '.gjaw-heart[aria-pressed="true"] svg,.gjaw-save[aria-pressed="true"] svg,.gjaw-pdp[aria-pressed="true"] svg{fill:currentColor}' +
    '.aaf-card-image,.sbp__card,.sbp__img,.product_gallery{position:relative}' +
    '.product_gallery > .gjaw-heart{bottom:14px;right:14px;z-index:5;width:44px;height:44px}' +
    '.product_gallery > .gjaw-heart svg{width:22px;height:22px}' +
    '.gjaw-pdp{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin:10px 0 0;padding:12px;border:1px solid #111;background:#fff;color:#111;font:inherit;font-size:13px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}' +
    '.gjaw-hdr{position:relative;display:inline-flex;align-items:center;justify-content:center;gap:7px;vertical-align:middle;min-width:34px;height:40px;margin-right:6px;color:inherit;cursor:pointer;background:none;border:0;padding:0;font:inherit}' +
    '.gjaw-hdr .gjaw-ic{position:relative;display:inline-flex}' +
    '.gjaw-hdr svg{width:18px;height:18px}' +
    '.gjaw-hdr .gjaw-n{position:absolute;top:-7px;right:-9px;min-width:15px;height:15px;padding:0 4px;border-radius:8px;background:#d6334a;color:#fff;font-size:9px;line-height:15px;font-weight:700;text-align:center;letter-spacing:0}' +
    '.gjaw-hdr .gjaw-n:empty{display:none}' +
    '.gjaw-hdr .gjaw-lbl{display:none}' +
    '.top-bar--right-menu .gjaw-hdr{padding:0 14px 0 6px;margin-right:0;gap:14px}' +
    '.top-bar--right-menu .gjaw-hdr .gjaw-lbl{display:inline;font-size:12px;font-weight:400;letter-spacing:1px;text-transform:uppercase;line-height:1}' +
    '.top-bar--right-menu .gjaw-hdr .gjaw-n{right:-11px}' +
    '@media (max-width:798px){.top-bar--right .gjaw-hdr{width:26px;margin-right:0}.top-bar--right .icon-search{padding-left:4px!important;padding-right:4px!important}}' +
    '.gjaw-ov{position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:2147483000;opacity:0;pointer-events:none;transition:opacity .2s}' +
    '.gjaw-ov.on{opacity:1;pointer-events:auto}' +
    '.gjaw-dr{position:fixed;top:0;right:0;bottom:0;width:min(400px,92vw);background:#fff;color:#111;z-index:2147483001;transform:translateX(100%);transition:transform .25s;display:flex;flex-direction:column;font-family:inherit;box-shadow:-4px 0 18px rgba(0,0,0,.12)}' +
    '.gjaw-dr.on{transform:none}' +
    '.gjaw-dr header{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid #e4e4e4}' +
    '.gjaw-dr h2{margin:0;font-size:18px;text-transform:none;letter-spacing:0}' +
    '.gjaw-x{border:0;background:none;font-size:26px;line-height:1;cursor:pointer;color:#111;padding:0 4px}' +
    '.gjaw-list{flex:1;overflow:auto;padding:8px 20px;margin:0;list-style:none}' +
    '.gjaw-it{display:grid;grid-template-columns:64px 1fr auto;gap:12px;align-items:center;padding:12px 0;border-bottom:1px solid #f0f0f0}' +
    '.gjaw-it img{width:64px;height:64px;object-fit:contain;background:#f6f6f6}' +
    '.gjaw-it a{color:#111;text-decoration:none;font-weight:600;font-size:14px;line-height:1.3}' +
    '.gjaw-it .pr{font-size:13px;color:#6f6e6e;margin-top:3px}' +
    '.gjaw-rm{border:0;background:none;color:#6f6e6e;font-size:12px;text-decoration:underline;cursor:pointer;padding:4px}' +
    '.gjaw-empty{padding:30px 4px;color:#6f6e6e;font-size:14px;line-height:1.5}' +
    '.gjaw-ft{padding:16px 20px 22px;border-top:1px solid #e4e4e4;display:grid;gap:8px}' +
    '.gjaw-btn{display:block;width:100%;padding:13px;border:1px solid #111;background:#111;color:#fff;font:inherit;font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;text-align:center;text-decoration:none;cursor:pointer}' +
    '.gjaw-btn.alt{background:#fff;color:#111}' +
    '.gjaw-note{font-size:12px;color:#6f6e6e;text-align:center;min-height:1em}' +
    '.gjaw-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);background:#111;color:#fff;padding:11px 16px;border-radius:4px;font-size:14px;z-index:2147483002;opacity:0;pointer-events:none;transition:all .2s;display:flex;gap:12px;align-items:center;max-width:92vw}' +
    '.gjaw-toast.on{opacity:1;transform:translateX(-50%);pointer-events:auto}' +
    '.gjaw-toast button,.gjaw-toast a{background:none;border:0;color:#fff;text-decoration:underline;font:inherit;cursor:pointer;padding:0}' +
    '.gjaw-dr .gjaw-it{align-items:start}' +
    '.gjaw-opts{display:flex;flex-wrap:wrap;gap:6px;margin:8px 0 6px}' +
    '.gjaw-opts label{display:flex;flex-direction:column;gap:2px;font-size:10px;letter-spacing:.06em;text-transform:uppercase;color:#6f6e6e}' +
    '.gjaw-opts select{font:inherit;font-size:13px;letter-spacing:0;text-transform:none;color:#111;padding:5px 24px 5px 8px;border:1px solid #cfcfcf;border-radius:3px;background:#fff;min-width:84px;max-width:150px}' +
    '.gjaw-loading{font-size:12px;color:#6f6e6e;margin:8px 0}' +
    '.gjaw-buy{display:flex;align-items:center;gap:10px}' +
    '.gjaw-buy .pr{margin:0;font-size:14px;color:#111;font-weight:600}' +
    '.gjaw-atc{border:1px solid #111;background:#111;color:#fff;font:inherit;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:7px 10px;cursor:pointer;border-radius:2px}' +
    '.gjaw-atc[disabled]{opacity:.45;cursor:default}';
  css += '' +
    '.gjaw-sh{position:fixed;inset:0;z-index:2147482999;background:#fff;color:#111;overflow:auto;-webkit-overflow-scrolling:touch;font-family:inherit;opacity:0;transition:opacity .2s}' +
    '.gjaw-sh.on{opacity:1}' +
    '.gjaw-sh-in{max-width:1100px;margin:0 auto;padding:28px 20px 40px}' +
    '.gjaw-sh-top{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;border-bottom:1px solid #e4e4e4;padding-bottom:18px;margin-bottom:22px}' +
    '.gjaw-sh-k{font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#6f6e6e;margin:0 0 6px}' +
    '.gjaw-sh h2{margin:0;font-size:26px;line-height:1.2;text-transform:none;letter-spacing:0;display:flex;align-items:center;gap:10px}' +
    '.gjaw-sh h2 svg{width:24px;height:24px;fill:#d6334a;stroke:#d6334a}' +
    '.gjaw-sh-sub{margin:6px 0 0;color:#6f6e6e;font-size:14px}' +
    '.gjaw-sh-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:26px 20px;list-style:none;margin:0;padding:0}' +
    '.gjaw-sc{display:flex;flex-direction:column;gap:6px}' +
    '.gjaw-sc-img{position:relative;display:grid;place-items:center;aspect-ratio:1/1;background:#f6f6f6;padding:14px}' +
    '.gjaw-sc-img img{max-width:100%;max-height:100%;object-fit:contain;box-shadow:0 2px 6px rgba(0,0,0,.15)}' +
    '.gjaw-sc-title{color:#111;text-decoration:none;font-weight:600;font-size:15px;line-height:1.3;margin-top:4px}' +
    '.gjaw-sc .pr{font-size:13px;color:#6f6e6e}' +
    '.gjaw-sc .gjaw-btn{margin-top:4px;padding:10px;font-size:12px}' +
    '.gjaw-sh-ft{display:flex;flex-wrap:wrap;gap:10px;justify-content:center;margin-top:34px;padding-top:22px;border-top:1px solid #e4e4e4}' +
    '.gjaw-sh-ft .gjaw-btn{width:auto;min-width:240px}' +
    '@media (max-width:600px){.gjaw-sh-grid{grid-template-columns:1fr 1fr;gap:20px 12px}.gjaw-sh h2{font-size:21px}.gjaw-sh-ft .gjaw-btn{width:100%}}';
  var st = document.createElement('style'); st.id = 'gjaw-css'; st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg, withView, extra) {
    if (!toastEl || !document.body.contains(toastEl)) {
      toastEl = document.createElement('div'); toastEl.className = 'gjaw-toast'; toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + (withView ? '<button type="button" data-gjaw-open>View wishlist</button>' : '') + (extra || '');
    toastEl.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 3200);
  }

  /* ---------- buttons ---------- */
  function heartBtn(h, title) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'gjaw-heart'; b.setAttribute('data-gjaw', h);
    b.setAttribute('aria-label', 'Save ' + (title || 'this print') + ' to your wishlist');
    b.innerHTML = HEART; setState(b);
    return b;
  }
  function setState(b) {
    var on = has(b.getAttribute('data-gjaw'));
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    var lab = b.querySelector('.gjaw-lab');
    if (lab) lab.textContent = on ? (b.classList.contains('gjaw-pdp') ? 'Saved to wishlist' : 'Saved') : (b.classList.contains('gjaw-pdp') ? 'Save to wishlist' : 'Save');
  }
  function syncButtons() {
    document.querySelectorAll('[data-gjaw]').forEach(setState);
    var n = items.length ? String(items.length) : '';
    document.querySelectorAll('.gjaw-hdr .gjaw-n').forEach(function (e) { e.textContent = n; });
    if (drawer && drawer.classList.contains('on') && drawerMode === 'mine') renderDrawer();
  }

  // One capture-phase listener so hearts inside links never navigate.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gjaw]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var card = b.closest('.aaf-card, .sbp__card, .gjaw-sc');
      var img = card && card.querySelector('img');
      var t = (card && (card.querySelector('.aaf-card-title, .sbp__title, [class*="title"]') || {}).textContent) || (img && img.alt) || '';
      toggle(b.getAttribute('data-gjaw'), { t: t.trim(), img: img ? img.currentSrc || img.src : '' });
      return;
    }
    if (e.target.closest && e.target.closest('[data-gjaw-open]')) { e.preventDefault(); e.stopPropagation(); openDrawer(); }
  }, true);

  /* ---------- drawer ---------- */
  var drawer, overlay, drawerMode = 'mine', sharedList = [];
  function ensureDrawer() {
    if (drawer && document.body.contains(drawer)) return;
    overlay = document.createElement('div'); overlay.className = 'gjaw-ov';
    drawer = document.createElement('aside'); drawer.className = 'gjaw-dr';
    drawer.setAttribute('role', 'dialog'); drawer.setAttribute('aria-modal', 'true'); drawer.setAttribute('aria-label', 'Your wishlist');
    document.body.appendChild(overlay); document.body.appendChild(drawer);
    overlay.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.gjaw-x')) closeDrawer();
      var rm = t.closest('.gjaw-rm'); if (rm) remove(rm.getAttribute('data-h'));
      if (t.closest('.gjaw-share')) share();
      if (t.closest('.gjaw-email')) emailList();
      var atc = t.closest('.gjaw-atc');
      if (atc) {
        var row = atc.closest('[data-h]'), h = row.getAttribute('data-h'), pr = rawCache[h];
        if (pr) addToCart([chosenVariant(pr, h).id], atc);
      }
      var all = t.closest('.gjaw-addall');
      if (all) addToCart(cartIds().ids, all);
      if (t.closest('.gjaw-takeall')) {
        sharedList.forEach(function (it) { if (!has(it.h)) items.push({ h: it.h, t: it.t, img: it.img, p: it.p, pv: it.pv, ty: it.ty, at: Date.now() }); });
        save(); drawerMode = 'mine'; renderDrawer(); toast('Added to your wishlist');
      }
    });
    drawer.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('select.gjaw-opt'); if (!s) return;
      var row = s.closest('[data-h]'), h = row.getAttribute('data-h'), p = rawCache[h]; if (!p) return;
      var cur = chosenVariant(p, h), vals = cur.options.slice(), i = +s.getAttribute('data-i');
      vals[i] = s.value;
      var v = matchVariant(p, vals, i) || cur;
      sel[h] = v.id; saveSel();
      // reflect the chosen variant (another option may have changed to keep a valid combination)
      row.querySelectorAll('select.gjaw-opt').forEach(function (x) { x.value = v.options[+x.getAttribute('data-i')]; });
      row.querySelector('.gjaw-buy .pr').textContent = money(v.price);
      var b = row.querySelector('.gjaw-atc'); b.disabled = !v.available; b.textContent = v.available ? 'Add to cart' : 'Sold out';
      updateAddAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('on')) closeDrawer(); });
  }
  function itemRow(it, removable) {
    var price = it.p != null ? '<div class="pr">' + (it.pv ? 'From ' : '') + money(it.p) + '</div>' : '';
    return '<li class="gjaw-it"><img src="' + esc(sized(it.img, 160)) + '" alt="" loading="lazy">' +
      '<div><a href="/products/' + encodeURIComponent(it.h) + '">' + esc(shortTitle(it.t) || it.h) + '</a>' + price + '</div>' +
      (removable ? '<button type="button" class="gjaw-rm" data-h="' + esc(it.h) + '">Remove</button>' : '<span></span>') + '</li>';
  }
  // wishlist row with size / frame dropdowns, live price and Add to cart
  function buyRow(it) {
    var p = rawCache[it.h], body;
    if (!p) body = '<div class="gjaw-loading">Loading options…</div>';
    else {
      var v = chosenVariant(p, it.h);
      var opts = (p.options || []).map(function (o, i) {
        var vals = o.values || [];
        if (vals.length < 2) return '';
        var lbl = optLabel(o.name || '');
        // label sits inside the dropdown ("Size: A4") to save a line
        return '<label><select class="gjaw-opt" data-i="' + i + '" aria-label="' + esc(lbl) + '">' +
          vals.map(function (val) { return '<option value="' + esc(val) + '"' + (v.options[i] === val ? ' selected' : '') + '>' + esc(lbl) + ': ' + esc(val) + '</option>'; }).join('') +
          '</select></label>';
      }).join('');
      body = (opts ? '<div class="gjaw-opts">' + opts + '</div>' : '<div class="gjaw-opts"></div>') +
        '<div class="gjaw-buy"><span class="pr">' + money(v.price) + '</span>' +
        '<button type="button" class="gjaw-atc"' + (v.available ? '' : ' disabled') + '>' + (v.available ? 'Add to cart' : 'Sold out') + '</button></div>';
    }
    return '<li class="gjaw-it" data-h="' + esc(it.h) + '"><img src="' + esc(sized(it.img, 160)) + '" alt="" loading="lazy">' +
      '<div><a href="/products/' + encodeURIComponent(it.h) + '">' + esc(shortTitle(it.t) || it.h) + '</a>' + body + '</div>' +
      '<button type="button" class="gjaw-rm" data-h="' + esc(it.h) + '">Remove</button></li>';
  }
  function cartIds() {
    var ids = [], total = 0;
    items.forEach(function (it) {
      var p = rawCache[it.h]; if (!p) return;
      var v = chosenVariant(p, it.h);
      if (v && v.available) { ids.push(v.id); total += v.price; }
    });
    return { ids: ids, total: total };
  }
  function updateAddAll() {
    var b = drawer && drawer.querySelector('.gjaw-addall'); if (!b) return;
    var c = cartIds();
    b.disabled = !c.ids.length;
    b.textContent = 'Add all to cart' + (c.ids.length ? ' · ' + money(c.total) : '');
  }
  function renderDrawer() {
    if (drawerMode === 'shared') {
      drawer.innerHTML = '<header><h2>Prints shared with you</h2><button type="button" class="gjaw-x" aria-label="Close">&times;</button></header>' +
        '<ul class="gjaw-list">' + sharedList.map(function (it) { return itemRow(it, false); }).join('') + '</ul>' +
        '<div class="gjaw-ft"><button type="button" class="gjaw-btn gjaw-takeall">Add all to my wishlist</button></div>';
      return;
    }
    var n = items.length;
    var scroll = (drawer.querySelector('.gjaw-list') || {}).scrollTop || 0;
    drawer.innerHTML = '<header><h2>Your wishlist' + (n ? ' (' + n + ')' : '') + '</h2><button type="button" class="gjaw-x" aria-label="Close">&times;</button></header>' +
      (n ? '<ul class="gjaw-list">' + items.map(buyRow).join('') + '</ul>'
         : '<div class="gjaw-list"><p class="gjaw-empty">Nothing saved yet. Tap the heart on any print in the art finder, palette search or a product page and it will appear here, and in the Art Wall Planner.</p></div>') +
      (n ? '<div class="gjaw-ft"><button type="button" class="gjaw-btn gjaw-addall">Add all to cart</button>' +
           '<button type="button" class="gjaw-btn alt gjaw-email">Email wishlist</button>' +
           '<button type="button" class="gjaw-btn alt gjaw-share">Share my list</button><div class="gjaw-note" aria-live="polite"></div></div>' : '');
    var list = drawer.querySelector('.gjaw-list'); if (list) list.scrollTop = scroll;
    updateAddAll();
    var missing = items.filter(function (it) { return !rawCache[it.h]; });
    if (missing.length) Promise.all(missing.map(function (it) { return product(it.h); })).then(function () {
      if (drawer.classList.contains('on') && drawerMode === 'mine') renderDrawer();
    });
  }
  function openDrawer(mode) {
    ensureDrawer(); drawerMode = mode || 'mine'; renderDrawer();
    requestAnimationFrame(function () { overlay.classList.add('on'); drawer.classList.add('on'); });
    var x = drawer.querySelector('.gjaw-x'); if (x) x.focus();
  }
  function closeDrawer() { if (!drawer) return; overlay.classList.remove('on'); drawer.classList.remove('on'); }
  function shareLink() { return location.origin + '/?wishlist=' + items.map(function (i) { return encodeURIComponent(i.h); }).join(','); }
  function share() {
    var link = shareLink(), note = drawer.querySelector('.gjaw-note');
    if (navigator.share) { navigator.share({ title: 'My Glenn Jones Art wishlist', url: link }).catch(function () {}); return; }
    (navigator.clipboard ? navigator.clipboard.writeText(link) : Promise.reject()).then(function () {
      if (note) note.textContent = 'Link copied. Send it to anyone you like.';
    }).catch(function () { if (note) note.textContent = link; });
  }
  // Opens the customer's email app with a short message and the link to the shared-list page (which shows the pictures).
  function emailList() {
    var body = 'Hi,\n\nHere are some Glenn Jones Art prints I love. You can see them all here:\n' + shareLink() + '\n';
    location.href = 'mailto:?subject=' + encodeURIComponent('My Glenn Jones Art wishlist') + '&body=' + encodeURIComponent(body);
  }
  // Copies the list as a formatted block (picture, name, price, link per print) that pastes into Gmail / Outlook / Apple Mail.
  function copyForEmail() {
    var note = drawer.querySelector('.gjaw-note'), o = location.origin;
    function abs(u) { return !u ? '' : u.indexOf('//') === 0 ? 'https:' + u : u; }
    var rows = items.map(function (it) {
      var url = o + '/products/' + encodeURIComponent(it.h), t = esc(shortTitle(it.t) || it.h);
      var price = it.p != null ? (it.pv ? 'From ' : '') + money(it.p) : '';
      return '<tr><td style="padding:8px 16px 8px 0;vertical-align:middle"><a href="' + url + '"><img src="' + esc(sized(abs(it.img), 300)) + '" width="110" alt="' + t + '" style="display:block;width:110px;height:auto;border:0"></a></td>' +
        '<td style="padding:8px 0;vertical-align:middle;font-family:Arial,Helvetica,sans-serif"><a href="' + url + '" style="color:#111111;font-weight:bold;font-size:15px;text-decoration:none">' + t + '</a>' +
        (price ? '<br><span style="color:#6f6e6e;font-size:13px">' + price + '</span>' : '') +
        '<br><a href="' + url + '" style="color:#d6334a;font-size:13px">View print</a></td></tr>';
    }).join('');
    var html = '<div style="font-family:Arial,Helvetica,sans-serif;color:#111111">' +
      '<p style="font-size:17px;font-weight:bold;margin:0 0 6px">My Glenn Jones Art wishlist</p>' +
      '<table cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse">' + rows + '</table>' +
      '<p style="font-size:14px;margin:14px 0 0"><a href="' + esc(shareLink()) + '" style="color:#111111">See the whole list on glennjonesart.com</a></p></div>';
    var text = 'My Glenn Jones Art wishlist\n\n' + items.map(function (it) {
      return (shortTitle(it.t) || it.h) + (it.p != null ? ' (' + (it.pv ? 'from ' : '') + money(it.p) + ')' : '') + '\n' + o + '/products/' + encodeURIComponent(it.h);
    }).join('\n\n') + '\n\nSee the whole list: ' + shareLink();
    function done() { if (note) note.textContent = 'Copied. Paste it into an email.'; }
    function fallback() {
      var d = document.createElement('div');
      d.contentEditable = 'true'; d.innerHTML = html;
      d.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
      document.body.appendChild(d);
      var r = document.createRange(); r.selectNodeContents(d);
      var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
      s.removeAllRanges(); d.remove();
      if (ok) done(); else if (note) note.textContent = 'Sorry, copying isn\'t supported in this browser. Try Share my list.';
    }
    if (navigator.clipboard && window.ClipboardItem) {
      navigator.clipboard.write([new ClipboardItem({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([text], { type: 'text/plain' })
      })]).then(done, fallback);
    } else fallback();
  }

  // Full-page view for someone opening a shared wishlist link
  var shEl;
  function openShared() {
    if (shEl) shEl.remove();
    shEl = document.createElement('div'); shEl.className = 'gjaw-sh';
    shEl.setAttribute('role', 'dialog'); shEl.setAttribute('aria-modal', 'true'); shEl.setAttribute('aria-label', 'Shared wishlist');
    var n = sharedList.length;
    shEl.innerHTML = '<div class="gjaw-sh-in"><div class="gjaw-sh-top"><div><p class="gjaw-sh-k">Glenn Jones Art</p>' +
      '<h2>' + HEART + 'A wishlist shared with you</h2><p class="gjaw-sh-sub">Tap the heart to save any to your own wishlist.</p></div>' +
      '<button type="button" class="gjaw-x" aria-label="Close">&times;</button></div>' +
      '<ul class="gjaw-sh-grid">' + sharedList.map(function (it) {
        var url = '/products/' + encodeURIComponent(it.h), t = esc(shortTitle(it.t) || it.h);
        return '<li class="gjaw-sc"><a class="gjaw-sc-img" href="' + url + '"><img src="' + esc(sized(it.img, 600)) + '" alt="' + t + '" loading="lazy"></a>' +
          '<a class="gjaw-sc-title" href="' + url + '">' + t + '</a>' +
          (it.p != null ? '<span class="pr">' + (it.pv ? 'From ' : '') + money(it.p) + '</span>' : '') +
          '<a class="gjaw-btn alt" href="' + url + '">View on website</a></li>';
      }).join('') + '</ul>' +
      '<div class="gjaw-sh-ft"><button type="button" class="gjaw-btn gjaw-sh-all">Save all to my wishlist</button>' +
      '<button type="button" class="gjaw-btn alt gjaw-sh-close">Keep browsing the shop</button></div></div>';
    document.body.appendChild(shEl);
    // heart on each picture (uses the same save logic as everywhere else)
    shEl.querySelectorAll('.gjaw-sc').forEach(function (c, i) { c.querySelector('.gjaw-sc-img').appendChild(heartBtn(sharedList[i].h, shortTitle(sharedList[i].t))); });
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { shEl.classList.add('on'); });
    function close() { shEl.classList.remove('on'); document.documentElement.style.overflow = ''; setTimeout(function () { shEl && shEl.remove(); shEl = null; }, 200); document.removeEventListener('keydown', esc1); }
    function esc1(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', esc1);
    shEl.addEventListener('click', function (e) {
      if (e.target.closest('.gjaw-x, .gjaw-sh-close')) close();
      if (e.target.closest('.gjaw-sh-all')) {
        sharedList.forEach(function (it) { if (!has(it.h)) items.push({ h: it.h, t: it.t, img: it.img, p: it.p, pv: it.pv, ty: it.ty, at: Date.now() }); });
        save(); toast('Saved to your wishlist', true);
      }
    });
    shEl.querySelector('.gjaw-x').focus();
  }

  function checkSharedLink() {
    var sp = new URLSearchParams(location.search), w = sp.get('wishlist');
    if (!w) return;
    var hs = w.split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 30);
    if (!hs.length) return;
    Promise.all(hs.map(function (h) { return info(h).then(function (d) { return d ? { h: h, t: d.t, img: d.img, p: d.p, pv: d.pv, ty: d.ty } : null; }); }))
      .then(function (list) { sharedList = list.filter(Boolean); if (sharedList.length) openShared(); });
  }

  /* ---------- decorate the page ---------- */
  function decorate() {
    // header heart, next to every cart icon (desktop, sticky and mobile headers)
    document.querySelectorAll('.cart-container').forEach(function (c) {
      if (c.previousElementSibling && c.previousElementSibling.classList.contains('gjaw-hdr')) return;
      var a = document.createElement('button');
      a.type = 'button'; a.className = 'gjaw-hdr'; a.setAttribute('data-gjaw-open', ''); a.setAttribute('aria-label', 'Wishlist');
      a.innerHTML = '<span class="gjaw-ic">' + HEART + '<span class="gjaw-n">' + (items.length || '') + '</span></span><span class="gjaw-lbl">Wishlist</span>';
      c.parentNode.insertBefore(a, c);
      // match the colour of the neighbouring header icons (white on the black bars, dark on the sticky header)
      var near = [].slice.call(c.parentNode.querySelectorAll('a')).filter(function (x) { return !x.closest('.cart-container'); })[0];
      if (near) a.style.color = getComputedStyle(near).color;
    });

    // AI Art Finder results
    document.querySelectorAll('.aaf-card').forEach(function (card) {
      var link = card.querySelector('a.aaf-card-image'); if (!link) return;
      var h = handleFrom(link.getAttribute('href')); if (!h) return;
      var title = (card.querySelector('.aaf-card-title') || {}).textContent || '';
      if (!link.querySelector('.gjaw-heart')) link.appendChild(heartBtn(h, title.trim()));
    });

    // Shop by Palette results (each card is a link); the heart sits on the image
    document.querySelectorAll('a.sbp__card').forEach(function (card) {
      if (card.querySelector('.gjaw-heart')) return;
      var h = handleFrom(card.getAttribute('href')); if (!h) return;
      var img = card.querySelector('img');
      (card.querySelector('.sbp__img') || card).appendChild(heartBtn(h, img && img.alt));
    });

    // Product page: save button under Add to cart
    var ph = /\/products\/([^\/?#]+)/i.exec(location.pathname); // also matches /collections/x/products/y
    if (ph) {
      // heart on the main product image (stays put as customers swipe through the gallery)
      var gal = document.querySelector('.product_gallery');
      if (gal && !gal.querySelector(':scope > .gjaw-heart')) {
        var ttl = (document.querySelector('h1') || {}).textContent || '';
        gal.appendChild(heartBtn(decodeURIComponent(ph[1]), ttl.trim()));
      }
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form && !form.querySelector('.gjaw-pdp')) {
        var atc = form.querySelector('[type="submit"], .add_to_cart, button[name="add"]');
        if (atc) {
          var p = document.createElement('button');
          p.type = 'button'; p.className = 'gjaw-pdp'; p.setAttribute('data-gjaw', decodeURIComponent(ph[1]));
          p.innerHTML = HEART + '<span class="gjaw-lab">Save to wishlist</span>'; setState(p);
          (atc.closest('.purchase, .product-add, .add-to-cart-wrap') || atc).insertAdjacentElement('afterend', p);
        }
      }
    }

    planner();
  }

  /* ---------- Art Wall Planner: "Your saved prints" panel ---------- */
  var plannerUnsub = null;
  function planner() {
    var host = document.querySelector('.gja-rp-host');
    var sr = host && host.shadowRoot; if (!sr) return;
    var browse = sr.querySelector('aside.browse'); var thumbs = sr.getElementById('thumbs');
    if (!browse || !thumbs || !thumbs.querySelector('.thumb')) return; // wait until prints have loaded
    if (sr.getElementById('gjaw-saved')) return;

    var style = document.createElement('style');
    style.textContent =
      '#gjaw-saved{margin:4px 0 14px;padding:12px;border:1px solid var(--line);border-radius:4px;background:var(--accent-soft)}' +
      '#gjaw-saved .hd{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:8px}' +
      '#gjaw-saved h3{margin:0;font-family:var(--display);font-size:15px;display:flex;align-items:center;gap:6px}' +
      '#gjaw-saved h3 svg{width:16px;height:16px;fill:#d6334a;stroke:#d6334a}' +
      '#gjaw-saved .all{font:inherit;font-size:11px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;padding:6px 9px;border:1px solid var(--ink);background:var(--ink);color:var(--accent-ink);border-radius:3px;cursor:pointer;white-space:nowrap}' +
      '#gjaw-saved .row{display:grid;grid-auto-flow:column;grid-auto-columns:92px;gap:8px;overflow-x:auto;padding-bottom:4px}' +
      '#gjaw-saved .s{font:inherit;position:relative;border:1px solid var(--line);background:#fff;border-radius:3px;padding:6px;cursor:pointer;display:grid;gap:4px;text-align:left;color:var(--ink)}' +
      '#gjaw-saved .s:hover{border-color:var(--accent)}' +
      '#gjaw-saved .s .a{display:grid;place-items:center;height:70px}' +
      '#gjaw-saved .s img{max-height:70px;max-width:100%;box-shadow:0 1px 3px rgba(0,0,0,.18)}' +
      '#gjaw-saved .s .t{font-size:11px;line-height:1.25;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
      '#gjaw-saved .s .pl{position:absolute;top:4px;right:4px;width:18px;height:18px;border-radius:50%;background:var(--ink);color:#fff;font-size:13px;line-height:18px;text-align:center}' +
      '#gjaw-saved .s[disabled]{opacity:.45;cursor:default}' +
      '#gjaw-saved .e{font-size:12px;color:var(--muted);margin:0;line-height:1.45}' +
      '#gjaw-saved.flash{animation:gjawf 1.6s ease}@keyframes gjawf{0%,60%{box-shadow:0 0 0 3px #d6334a}100%{box-shadow:none}}';
    sr.appendChild(style);

    var box = document.createElement('section'); box.id = 'gjaw-saved'; box.setAttribute('aria-label', 'Your wishlist prints');
    var h2 = browse.querySelector('h2');
    (h2 || browse.firstChild).insertAdjacentElement(h2 ? 'afterend' : 'beforebegin', box);

    function render(all) {
      var list = all.filter(isPlannerPrint);
      if (!list.length) {
        box.innerHTML = '<div class="hd"><h3>' + HEART + 'Your wishlist prints</h3></div>' +
          '<p class="e">Tap the heart on prints in the art finder, palette search or any product page and they will be ready here to try on your wall.</p>';
        return;
      }
      box.innerHTML = '<div class="hd"><h3>' + HEART + 'Your wishlist prints (' + list.length + ')</h3>' +
        (list.length > 1 ? '<button type="button" class="all">Add all</button>' : '') + '</div>' +
        '<div class="row">' + list.map(function (it) {
          return '<button type="button" class="s" data-h="' + esc(it.h) + '" aria-label="Add ' + esc(shortTitle(it.t)) + ' to the wall">' +
            '<span class="pl" aria-hidden="true">+</span><span class="a"><img src="' + esc(sized(it.img, 200)) + '" alt="" loading="lazy"></span>' +
            '<span class="t">' + esc(shortTitle(it.t) || it.h) + '</span></button>';
        }).join('') + '</div>';
    }

    box.addEventListener('click', function (e) {
      var b = e.target.closest('.s');
      if (b) { if (!b.disabled) addToWall(sr, b.getAttribute('data-h'), b); return; }
      if (e.target.closest('.all')) {
        var onWall = [];
        try { onWall = (JSON.parse(localStorage.getItem('gja-room-planner-live-v1')) || {}).prints.map(function (p) { return p.id; }); } catch (err) {}
        var list = items.filter(function (it) { return isPlannerPrint(it) && onWall.indexOf(it.h) < 0; }).slice(0, 8), i = 0;
        if (!list.length) { toast('Your saved prints are already on the wall'); return; }
        (function next() { if (i >= list.length) return; addToWall(sr, list[i++].h).then(next); })();
      }
    });

    if (plannerUnsub) plannerUnsub();
    plannerUnsub = api.subscribe(render);

    if (new URLSearchParams(location.search).get('saved')) {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      box.classList.add('flash');
    }
  }

  function waitFor(fn, ms) {
    return new Promise(function (res) {
      var t0 = Date.now();
      (function tick() { var v = fn(); if (v || Date.now() - t0 > ms) return res(v || null); setTimeout(tick, 60); })();
    });
  }
  // Uses the planner's own print buttons, so prints go on the wall exactly as if picked from its list.
  function addToWall(sr, h, btn) {
    var sel = '#thumbs [data-add="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]';
    var it = find(h) || {};
    var q = sr.getElementById('q'), prev = q ? q.value : '';
    var allChip = sr.querySelector('[data-theme-f="All"]');
    var anyChip = sr.querySelector('[data-o="any"]');
    var found = sr.querySelector(sel);
    var p = Promise.resolve(found);
    if (!found && q) {
      if (allChip && allChip.getAttribute('aria-pressed') !== 'true') allChip.click();
      if (anyChip && anyChip.getAttribute('aria-pressed') !== 'true') anyChip.click();
      q.value = shortTitle(it.t) || h.replace(/-art-print$/, '').replace(/-/g, ' ');
      q.dispatchEvent(new Event('input', { bubbles: true }));
      p = waitFor(function () { return sr.querySelector(sel); }, 2500);
    }
    return p.then(function (b) {
      if (b) b.click();
      else {
        toast('Sorry, ' + (shortTitle(it.t) || 'that print') + " isn't available in the planner");
        if (btn) btn.setAttribute('disabled', '');
      }
      if (q && q.value !== prev) { q.value = prev; q.dispatchEvent(new Event('input', { bubbles: true })); }
      return new Promise(function (r) { setTimeout(r, 120); });
    });
  }

  /* ---------- public API ---------- */
  var api = window.GJAWishlist = {
    get items() { return items.slice(); },
    has: has, add: add, remove: remove, toggle: toggle,
    open: function () { openDrawer(); }, close: closeDrawer,
    subscribe: function (f) { subs.push(f); try { f(items.slice()); } catch (e) {} return function () { subs = subs.filter(function (x) { return x !== f; }); }; }
  };

  // Fill in any missing titles/prices for older saves
  items.forEach(function (it) { if (!it.t || it.p == null || it.ty == null) enrich(it.h); });

  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; try { decorate(); } catch (e) {} }); }
  function start() {
    decorate(); checkSharedLink();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    // the planner builds inside its own shadow root, so poll briefly until its prints are loaded
    var n = 0, iv = setInterval(function () { schedule(); if (++n > 40) clearInterval(iv); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
